var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0.0.0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["ascendtravel@ascendtravel"]={id:"0.0.0"};
      


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/webpack-plugin/src/sentry-webpack.module.js
// module id = 97
// module chunks = 26